export const parseKeyBoardNavigation = (keyboardOptions) => {
    if (keyboardOptions === true) {
        return {
            enabled: true,
            onlyInViewport: true,
            pageUpDown: true,
        };
    }
    if (keyboardOptions === false) {
        return {
            enabled: false,
        };
    }
    return {
        ...keyboardOptions,
    };
};
//# sourceMappingURL=carousel.utils.js.map